import { render, staticRenderFns } from "./InvoiceContainer.vue?vue&type=template&id=08dff961&"
import script from "./InvoiceContainerVue.ts?vue&type=script&lang=ts&"
export * from "./InvoiceContainerVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports